import { render } from "./DealOwnership.vue?vue&type=template&id=64e49c54&scoped=true"
import script from "./DealOwnership.vue?vue&type=script&lang=js"
export * from "./DealOwnership.vue?vue&type=script&lang=js"

import "./DealOwnership.vue?vue&type=style&index=0&id=64e49c54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e49c54"]])

export default __exports__